// extracted by mini-css-extract-plugin
export default {"l_ErrorIcon_main":"ErrorIcon_l_ErrorIcon_main__t+vtI","l_ErrorIcon_img":"ErrorIcon_l_ErrorIcon_img__3lH4B"};